import mobileAppHandler from './utils/mobile-app';

const getUserRoles = () => {
  if (window.sdc && window.sdc.authManager) {
    const roles = window.sdc.authManager.getRoles();
    if (roles && Array.isArray(roles)) {
      return [...roles, 'invalidPackage'];
    }
  }

  return ['unauthenticated'];
};

export default function(rootElement) {
  const modal = document.querySelector('[data-component-name="sdc-site-modal"]');
  const livestreamToggle = rootElement.querySelector('[data-role="livestream-toggle"]');

  if (modal && livestreamToggle) {
    livestreamToggle.addEventListener('click', (e) => {
      if (mobileAppHandler(livestreamToggle)) {
        return;
      }

      const contentLocation = livestreamToggle.getAttribute('data-modal-content');
      let contentElement = rootElement.querySelector(contentLocation);

      const userRoles = getUserRoles();
      const modalContentList = rootElement.querySelectorAll('[data-role="modal-content"]');

      for (let i = 0; i < modalContentList.length; i++) {
        const modalRole = modalContentList[i].getAttribute('modal-role');

        if (userRoles.indexOf(modalRole) >= 0) {
          contentElement = modalContentList[i];
          break;
        }
      }

      if (!window.sdc.openModal) {
        return;
      }

      e.preventDefault();
      window.sdc.openModal(modal, contentElement);
    }, false);
  }
}
